/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 01.08.13
 * Time: 18:02
 * To change this template use File | Settings | File Templates.
 */
export class CampaignConstants {
    // These constants are used as keys for all marketing parameters in the CampaignVars class
    public static PARTNER_ID: string = "pid";
    public static LP_PARTNER_ID: string = "lppid";
    public static CHANNEL_ID: string = "cid";
    public static TRAFFIC_SOURCE: string = "tid";
    public static CREATIVE: string = "creative";
    public static PLACEMENT: string = "placement";
    public static KEYWORD: string = "keyword";
    public static NETWORK: string = "network";
    public static AID: string = "aid";
    public static CAMP: string = "camp";
    public static LP: string = "lp";
    public static ADGR: string = "adgr";
    public static MATCHTYPE: string = "matchtype";
    public static LANGUAGE: string = "lang";
    public static COUNTRY: string = "country";
}
